import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { GET_HOTEL_INFORMATION, HOTEL_AVAILABILITY_QUERY, Area, PROMO_CODE_COOKIE } from '@whitbread-eos/api';
import { VIEW_TYPE_CONSTANTS } from '@whitbread-eos/molecules';
import { getCookie, graphQLRequest } from '@whitbread-eos/utils';
import { add, differenceInDays, format } from 'date-fns';
var DEFAULT_SORT_VALUE = '1';
export function singleHotelSearchCCUI(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
  return _singleHotelSearchCCUI.apply(this, arguments);
}
function _singleHotelSearchCCUI() {
  _singleHotelSearchCCUI = _asyncToGenerator(function* (stayDetailsState, paramsMappedForURL, labels, URLToRedirect, queryParams, country, language, channel) {
    var _stayDetailsState$dat = stayDetailsState.data.info.suggestion.location,
      latitude = _stayDetailsState$dat.latitude,
      longitude = _stayDetailsState$dat.longitude;
    var location = "".concat(latitude, ",").concat(longitude);
    var listView = VIEW_TYPE_CONSTANTS.listView;
    var redirectToSrpLink = "/".concat(country, "/").concat(language, "/search.html?searchModel.searchTerm=").concat(paramsMappedForURL.searchTerm, "&LOCATION=").concat(location, "&").concat(URLToRedirect, "&BOOKINGCHANNEL=").concat(labels.bookingChannel, "&SORT=").concat(DEFAULT_SORT_VALUE, "&VIEW=").concat(listView);
    var hotelId = queryParams.code;
    if (!hotelId) {
      return "/".concat(country, "/").concat(language, "/search.html?searchModel.searchTerm=").concat(paramsMappedForURL.searchTerm, "&PLACEID=").concat(queryParams.placeId, "&").concat(URLToRedirect, "&BOOKINGCHANNEL=").concat(labels.bookingChannel, "&SORT=").concat(DEFAULT_SORT_VALUE, "&VIEW=").concat(listView);
    }
    var _yield$isHotelAvailab = yield isHotelAvailable({
        ARRyyyy: paramsMappedForURL.ARRyyyy,
        ARRmm: paramsMappedForURL.ARRmm,
        ARRdd: paramsMappedForURL.ARRdd,
        nights: paramsMappedForURL.nights,
        rooms: paramsMappedForURL.rooms,
        code: paramsMappedForURL.code
      }, country, language, labels.mappedRoomLabels, channel),
      isAvailable = _yield$isHotelAvailab.isAvailable,
      isOpeningSoon = _yield$isHotelAvailab.isOpeningSoon;
    URLToRedirect += "&BRAND=".concat(paramsMappedForURL.brand);
    return yield getSearchRedirectURL({
      isAvailable,
      isOpeningSoon,
      redirectToSrpLink,
      queryParams,
      country,
      language,
      URLToRedirect
    });
  });
  return _singleHotelSearchCCUI.apply(this, arguments);
}
export function singleHotelSearchPI(_x9, _x0, _x1, _x10, _x11, _x12, _x13, _x14) {
  return _singleHotelSearchPI.apply(this, arguments);
}
function _singleHotelSearchPI() {
  _singleHotelSearchPI = _asyncToGenerator(function* (stayDetailsState, paramsMappedForURL, labels, URLToRedirect, queryParams, country, language, channel) {
    var _stayDetailsState$dat2 = stayDetailsState.data.info.suggestion.location,
      latitude = _stayDetailsState$dat2.latitude,
      longitude = _stayDetailsState$dat2.longitude;
    var location = "".concat(latitude, ",").concat(longitude);
    var listView = VIEW_TYPE_CONSTANTS.listView;
    var redirectToSrpLink = "/".concat(country, "/").concat(language, "/search.html?searchModel.searchTerm=").concat(paramsMappedForURL.searchTerm, "&LOCATION=").concat(location, "&").concat(URLToRedirect, "&BOOKINGCHANNEL=").concat(labels.bookingChannel, "&SORT=").concat(DEFAULT_SORT_VALUE, "&VIEW=").concat(listView);
    var hotelId = queryParams.code;
    if (!hotelId) {
      return "/".concat(country, "/").concat(language, "/search.html?searchModel.searchTerm=").concat(paramsMappedForURL.searchTerm, "&PLACEID=").concat(queryParams.placeId, "&").concat(URLToRedirect, "&BOOKINGCHANNEL=").concat(labels.bookingChannel, "&SORT=").concat(DEFAULT_SORT_VALUE, "&VIEW=").concat(listView);
    }
    var _yield$isHotelAvailab2 = yield isHotelAvailable({
        ARRyyyy: paramsMappedForURL.ARRyyyy,
        ARRmm: paramsMappedForURL.ARRmm,
        ARRdd: paramsMappedForURL.ARRdd,
        nights: paramsMappedForURL.nights,
        rooms: paramsMappedForURL.rooms,
        code: paramsMappedForURL.code
      }, country, language, labels.mappedRoomLabels, channel),
      isAvailable = _yield$isHotelAvailab2.isAvailable,
      isOpeningSoon = _yield$isHotelAvailab2.isOpeningSoon;
    return yield getSearchRedirectURL({
      isAvailable,
      isOpeningSoon,
      redirectToSrpLink,
      queryParams,
      country,
      language,
      URLToRedirect
    });
  });
  return _singleHotelSearchPI.apply(this, arguments);
}
export function singleHotelSearchBB(_x15, _x16, _x17, _x18, _x19, _x20, _x21, _x22, _x23, _x24) {
  return _singleHotelSearchBB.apply(this, arguments);
}
function _singleHotelSearchBB() {
  _singleHotelSearchBB = _asyncToGenerator(function* (stayDetailsState, paramsMappedForURL, labels, URLToRedirect, queryParams, country, language, channel, variant, token) {
    var _stayDetailsState$dat3 = stayDetailsState.data.info.suggestion.location,
      latitude = _stayDetailsState$dat3.latitude,
      longitude = _stayDetailsState$dat3.longitude;
    var location = "".concat(latitude, ",").concat(longitude);
    var listView = VIEW_TYPE_CONSTANTS.listView;
    var redirectToSrpLink = "/".concat(country, "/").concat(language).concat(variant === 'bb' ? '/business-booker' : '', "/search.html?searchModel.searchTerm=").concat(paramsMappedForURL.searchTerm, "&LOCATION=").concat(location, "&").concat(URLToRedirect, "&BOOKINGCHANNEL=").concat(labels.bookingChannel, "&SORT=").concat(DEFAULT_SORT_VALUE, "&VIEW=").concat(listView);
    var hotelId = queryParams.code;
    if (!hotelId) {
      return "/".concat(country, "/").concat(language).concat(variant === 'bb' ? '/business-booker' : '', "/search.html?searchModel.searchTerm=").concat(paramsMappedForURL.searchTerm, "&PLACEID=").concat(queryParams.placeId, "&").concat(URLToRedirect, "&BOOKINGCHANNEL=").concat(labels.bookingChannel, "&SORT=").concat(DEFAULT_SORT_VALUE, "&VIEW=").concat(listView);
    }
    var _yield$isHotelAvailab3 = yield isHotelAvailable({
        ARRyyyy: paramsMappedForURL.ARRyyyy,
        ARRmm: paramsMappedForURL.ARRmm,
        ARRdd: paramsMappedForURL.ARRdd,
        nights: paramsMappedForURL.nights,
        rooms: paramsMappedForURL.rooms,
        code: paramsMappedForURL.code
      }, country, language, labels.mappedRoomLabels, channel, token),
      isAvailable = _yield$isHotelAvailab3.isAvailable,
      isOpeningSoon = _yield$isHotelAvailab3.isOpeningSoon;
    return yield getSearchRedirectURL({
      isAvailable,
      isOpeningSoon,
      redirectToSrpLink,
      queryParams,
      country,
      language,
      URLToRedirect,
      variant
    });
  });
  return _singleHotelSearchBB.apply(this, arguments);
}
export function isHotelAvailable(_x25, _x26, _x27, _x28, _x29, _x30) {
  return _isHotelAvailable.apply(this, arguments);
}
function _isHotelAvailable() {
  _isHotelAvailable = _asyncToGenerator(function* (_ref, country, language, mappedRoomLabels, channel, token) {
    var ARRyyyy = _ref.ARRyyyy,
      ARRmm = _ref.ARRmm,
      ARRdd = _ref.ARRdd,
      nights = _ref.nights,
      rooms = _ref.rooms,
      code = _ref.code;
    if (!code) {
      return {
        isOpeningSoon: false,
        isAvailable: true,
        hasMlos: false
      };
    }
    var isAvailable = false;
    var hasMlos = false;
    try {
      var hotelAvailabilityOpera = yield isOperaHotelAvailable({
        ARRyyyy,
        ARRmm,
        ARRdd,
        nights,
        rooms,
        code
      }, language, country, mappedRoomLabels, channel, token);
      isAvailable = hotelAvailabilityOpera === null || hotelAvailabilityOpera === void 0 ? void 0 : hotelAvailabilityOpera.isHotelAvailable;
      hasMlos = hotelAvailabilityOpera === null || hotelAvailabilityOpera === void 0 ? void 0 : hotelAvailabilityOpera.hasHotelMlos;
    } catch (e) {
      console.log(e);
    }
    var isOpeningSoon = yield isHotelOpeningSoon({
      ARRdd,
      ARRmm,
      ARRyyyy
    }, code, country, language);
    return {
      isOpeningSoon,
      isAvailable,
      hasMlos
    };
  });
  return _isHotelAvailable.apply(this, arguments);
}
export function HDPUrlToRedirectFormatter(URLToRedirect) {
  if (!URLToRedirect || URLToRedirect.indexOf('&') === -1) {
    return URLToRedirect;
  }
  var checkNoOfPairs = URLToRedirect.match(/&/g) || [];
  var checkNoOfParams = URLToRedirect.match(/=/g) || [];
  if ((checkNoOfPairs === null || checkNoOfPairs === void 0 ? void 0 : checkNoOfPairs.length) === 0 || (checkNoOfParams === null || checkNoOfParams === void 0 ? void 0 : checkNoOfParams.length) !== (checkNoOfPairs === null || checkNoOfPairs === void 0 ? void 0 : checkNoOfPairs.length) + 1) {
    return URLToRedirect;
  }
  return URLToRedirect.split('&').map(kvPair => {
    if (kvPair.indexOf('ARRdd') > -1 || kvPair.indexOf('ARRmm') > -1) {
      var _kvPair$split = kvPair.split('='),
        _kvPair$split2 = _slicedToArray(_kvPair$split, 2),
        key = _kvPair$split2[0],
        value = _kvPair$split2[1];
      return "".concat(key, "=").concat(('0' + value).slice(-2));
    }
    return kvPair;
  }).join('&');
}
export function getSearchRedirectURL(_x31) {
  return _getSearchRedirectURL.apply(this, arguments);
}
function _getSearchRedirectURL() {
  _getSearchRedirectURL = _asyncToGenerator(function* (_ref2) {
    var isAvailable = _ref2.isAvailable,
      isOpeningSoon = _ref2.isOpeningSoon,
      redirectToSrpLink = _ref2.redirectToSrpLink,
      queryParams = _ref2.queryParams,
      country = _ref2.country,
      language = _ref2.language,
      URLToRedirect = _ref2.URLToRedirect,
      variant = _ref2.variant;
    if (!isAvailable || isOpeningSoon) {
      return redirectToSrpLink;
    }
    var hotelSlug = yield getHotelSlugById(queryParams.code, country, language);
    if (hotelSlug) {
      return "/".concat(country, "/").concat(language).concat(variant === 'bb' ? '/business-booker' : '', "/hotels").concat(hotelSlug, ".html?").concat(HDPUrlToRedirectFormatter(URLToRedirect));
    }
  });
  return _getSearchRedirectURL.apply(this, arguments);
}
export function isOperaHotelAvailable(_x32, _x33, _x34, _x35, _x36, _x37) {
  return _isOperaHotelAvailable.apply(this, arguments);
}
function _isOperaHotelAvailable() {
  _isOperaHotelAvailable = _asyncToGenerator(function* (_ref3, language, country, mappedRoomLabels, bookingChannel, token) {
    var ARRyyyy = _ref3.ARRyyyy,
      ARRmm = _ref3.ARRmm,
      ARRdd = _ref3.ARRdd,
      nights = _ref3.nights,
      rooms = _ref3.rooms,
      code = _ref3.code;
    var startDate = new Date(Number(ARRyyyy), Number(ARRmm && ARRmm - 1), Number(ARRdd));
    var endDate = add(startDate, {
      days: Number(nights)
    });
    var availabilityQueryParams = {
      hotelId: code,
      arrival: format(startDate, 'yyyy-MM-dd'),
      departure: format(endDate, 'yyyy-MM-dd'),
      brand: Area.PI,
      country: country,
      rooms: rooms === null || rooms === void 0 ? void 0 : rooms.map(room => ({
        adultsNumber: room.adults,
        childrenNumber: room.children,
        cotRequired: room.shouldIncludeCot,
        roomType: room.roomType && mappedRoomLabels[room.roomType]
      })),
      language: language,
      bookingChannel: {
        channel: bookingChannel,
        language: language === null || language === void 0 ? void 0 : language.toUpperCase(),
        subchannel: 'WEB'
      },
      channel: bookingChannel,
      promotionCode: getCookie(PROMO_CODE_COOKIE)
    };
    var hotelAvailabilityResponse = yield graphQLRequest(HOTEL_AVAILABILITY_QUERY, availabilityQueryParams, token);
    var isHotelAvailable = hotelAvailabilityResponse.hotelAvailability.roomRates.length > 0 && hotelAvailabilityResponse.hotelAvailability.available;
    var hasHotelMlos = hotelAvailabilityResponse.hotelAvailability.mlos;
    return {
      isHotelAvailable,
      hasHotelMlos
    };
  });
  return _isOperaHotelAvailable.apply(this, arguments);
}
export function isHotelOpeningSoon(_x38, _x39, _x40, _x41) {
  return _isHotelOpeningSoon.apply(this, arguments);
}
function _isHotelOpeningSoon() {
  _isHotelOpeningSoon = _asyncToGenerator(function* (_ref4, hotelId, country, language) {
    var ARRdd = _ref4.ARRdd,
      ARRmm = _ref4.ARRmm,
      ARRyyyy = _ref4.ARRyyyy;
    var hotelResponse = yield graphQLRequest(GET_HOTEL_INFORMATION, {
      hotelId,
      country,
      language
    });
    var hotelOpeningDate = hotelResponse.hotelInformation.hotelOpeningDate;
    var selectedDate = new Date("".concat(ARRmm, "/\n      ").concat(ARRdd, "/\n      ").concat(ARRyyyy));
    var openingSoonDate = hotelOpeningDate !== '' && new Date(JSON.parse(JSON.stringify(hotelOpeningDate)));
    var isOpeningSoon = openingSoonDate && differenceInDays(openingSoonDate, selectedDate) > 0;
    return isOpeningSoon;
  });
  return _isHotelOpeningSoon.apply(this, arguments);
}
export function getHotelSlugById(_x42, _x43, _x44) {
  return _getHotelSlugById.apply(this, arguments);
}
function _getHotelSlugById() {
  _getHotelSlugById = _asyncToGenerator(function* (hotelId, country, language) {
    var hotelSlugByIdResponse = yield graphQLRequest(GET_HOTEL_INFORMATION, {
      hotelId,
      country,
      language
    });
    return hotelSlugByIdResponse.hotelInformation.links.detailsPage;
  });
  return _getHotelSlugById.apply(this, arguments);
}
export function mapMultiSearchToQueryParams(multiSearchParams) {
  return {
    ARRdd: multiSearchParams.arrivalDay,
    ARRmm: multiSearchParams.arrivalMonth,
    ARRyyyy: multiSearchParams.arrivalYear,
    searchTerm: multiSearchParams.location,
    nights: multiSearchParams.numberOfNights,
    rooms: mapMultiSearchRoomsToSearchRooms(multiSearchParams.rooms),
    roomsNumber: multiSearchParams.rooms.length,
    code: multiSearchParams.code
  };
}
export function mapMultiSearchRoomsToSearchRooms(rooms) {
  return rooms.map(room => {
    return {
      adults: room.adultsNumber,
      children: room.childrenNumber,
      roomType: room.type,
      shouldIncludeCot: false
    };
  });
}